// Packages
import PropTypes from 'prop-types'

// Components
import ContactForm from 'modules/Contacts/components/Form';

// Other
import useApi from 'hooks/useApi';

const ContactEditScreen = ({  itemId, onClose, onSubmit, parent, parentId }) => {

    const { data: item, put: updateItem, errors } = useApi('/contacts/' + itemId);

	const submit = async (values) => {

        if( await updateItem({[parent]: parentId, ...values}, 'Contact updated!')) {

            onSubmit();
        }
    }

    return(
        <ContactForm 
            errors={errors} 
            contact={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

ContactEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ContactEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')},
    parent: '',
    parentId: ''
}

export default ContactEditScreen;